import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

const LogoutPage = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout(); // Firebase sign-out + reset AuthContext (cart is cleared automatically)
        
        // Navigate to home page after logout
        navigate('/');
      } catch (error) {
        console.error('Logout error:', error);
        // Even if logout fails, redirect to home
        navigate('/');
      }
    };
    
    performLogout();
  }, [logout, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-lg font-medium">Signing you out...</p>
        <p className="text-sm text-muted-foreground">
          Please wait while we securely sign you out
        </p>
      </div>
    </div>
  );
};

export default LogoutPage;